/* ===============================
 * Constants & Selectors
 * =============================== */
const SEL = {
  container: '#product-list-container',
  goToCheckoutBtn: '.go-to-checkout',
  discountForm: '#discount-form',
  proteinFilterBtns: '#protein-filter button',
  restrictionFilterBtns: '#restriction-filter button',
  allCards: '.product-card:not(.breakfast)',
  allCardsNot: '.product-card:not(.alternative)',
  altCards: '.product-card.alternative',
  deliveryWidget: '.delivery-pickup-widget',
  selectDelivery: '.select-delivery',
  selectDate: '.select-date',
  renderCartItems: '.render-cart-items',
  cartTotalAmount: '.cart-total-amount .total-price-omt',
  cartComparePrice: '.cart-total-amount .compare-price',
  sectionProductsPlan: '.section-products__plan',
};
const key = "quiz_responses_v2";
const DELIVERY_CLASSES = [
  { cls: 'first-delivery',  label: 'First Delivery',  number: 1 },
  { cls: 'second-delivery', label: 'Second Delivery', number: 2 },
  { cls: 'third-delivery',  label: 'Third Delivery',  number: 3 },
  { cls: 'fourth-delivery', label: 'Fourth Delivery', number: 4 },
];

/* ===============================
 * Utilities
 * =============================== */
const getPlanFromPath = () => {
  const segments = new URL(window.location.href).pathname.split('/').filter(Boolean);
  return segments[segments.length - 1].replace('-one-month-trial', '');
};

const setQty = ($card, qty) => {
  const value = Number(qty) || 0;
  $card.data('product-quantity', value);
  $card.attr('data-product-quantity', value);
  $card
    .find('.product-card__icon-quantity .quantity')
    .contents()
    .filter((_, el) => el.nodeType === 3)
    .first()
    .replaceWith(`${value}x`);
};

const getDeliveryMeta = ($el) =>
  DELIVERY_CLASSES.find(d => $el.hasClass(d.cls));

const parseMaybeJsonTwice = (text) => {
  // Mantém a "dança" do código original, mas de forma segura.
  try {
    const once = JSON.parse(text);
    try { return JSON.parse(JSON.stringify(once)); } catch { return once; }
  } catch {
    // fallback: às vezes já vem objeto serializado em string
    try { return JSON.parse(JSON.parse(text)); } catch { return null; }
  }
};

/* ===============================
 * Bootstrap
 * =============================== */
$(async function init() {
  $('.total-price').addClass('hidden');
  await window.FormEvents.addAttributes({ weekActive: '' });
  await initPartner();
  await scrollMobile();
  await verifyDiscount();
  await loadMeals(0);
  await window.CartDrawerAPI.buildDeliveryDatesWidget();
  await constructionFromActiveCards();
  await changeDiscountDisplay('one-month');
  await calculateCartTotal();
});

$(document).on("change", ".delivery-pickup-widget select", async function (e) {
  console.log('Week selection changed');
  showLoading();
  const $selected = $(this).find("option:selected"); 
  const week = $selected.data("week");
  await window.FormEvents.addAttributes({ weekActive: week });
  $(SEL.proteinFilterBtns).removeClass('active selected');
  $(SEL.restrictionFilterBtns).removeClass('active selected');
  await loadMeals(week);
  await constructionFromActiveCards();
  hideLoading();
});

function showLoading() {
  $('.section-loading').css('display', 'flex');
}

function hideLoading() {
  $('.section-loading').css('display', 'none');
}

/* ===============================
 * Accordion behavior: keep one open
 * =============================== */
$(document).on('toggle', 'details.cart-accordion', function () {
  if (!this.open) return;
  const $container = $(this).closest(SEL.renderCartItems);
  $container.find('details.cart-accordion[open]').not(this).removeAttr('open');
});

//add class active toggle on title click
$(document).on('click', '.product-main__title', function () {
  const $details = $(this).closest('.product-main');
  if ($details.hasClass('active')) {
    $details.removeClass('active');
  } else {
    $details.addClass('active');
  }
});


/* ===============================
 * Go to checkout
 * =============================== */
$(document).on('click', SEL.goToCheckoutBtn, async function handleCheckout(e) {
  const $btn = $(this);
  $btn.prop('disabled', true).text('processing...');
  await window.FormEvents.clearCart();
  await window.FormEvents.clearCartAttributes();
  e.preventDefault();

  const $widget = $(SEL.deliveryWidget);
  const delivery = String($widget.find(SEL.selectDelivery).val());
  const dateInt = parseInt($widget.find(SEL.selectDate).val(), 10);
  const dateStr = formatDate(dateInt);

  await window.FormEvents.addAttributes({'_plan': 'One Month Trial'});
  await window.FormEvents.addAttributes({'_delivery_date': `${formatTimestampToDate(dateInt)}`});
  await window.FormEvents.addAttributes({ _checkout_delivery_date: `${delivery} - ${dateStr}` });
  await window.FormEvents.addAttributes({ _filter: buildFilterComposition() });

  const variantId = $(SEL.container).data('variantId');
  const formData = { items: [{ id: 44860389982387, quantity: 1, selling_plan: 3535405235 }] };
  const storage = localStorage.getItem(key);
  const quizComplete = storage ? JSON.parse(storage).winner : null;
  const getDiscountCode = quizComplete ? 'INTRO_80' : null;
  await window.FormEvents.addItem(formData, getDiscountCode);
  await addToCartWithProperties(variantId, 1, buildCompositionFromActiveCards());
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
      event: 'go_to_checkout_button_click',
      source: "one-month-trial"
  });
  const pageHandle = sessionStorage.getItem('page_handle') ?? '';
  if (pageHandle.includes('partner-')) {
      await FormEvents.addAttributes({'_origin_page': pageHandle}); 
      await addGiftPartnerProducts();
      return window.location.href = '/checkout?discount=72YBNR2P32R5,5B3A9NHS18RR,ZS8CZAFQ81MH';
  } else {
      await removeGiftPartnerProducts();
      return window.location.href = '/checkout?discount=%20';
  }
});

/* ===============================
 * Add to cart with properties
 * =============================== */
async function addToCartWithProperties(variantId, quantity = 1, properties = {}) {
  try {
    return await $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: { id: variantId, quantity, properties: { ...properties } },
    });
  } catch (err) {
    console.error('Erro ao adicionar produto com propriedades:', err);
    throw err;
  }
}

/* ===============================
 * Delivery compositions (properties)
 * =============================== */
function buildCompositionFromActiveCards() {
  const deliveries = [];

  $('.product-main').each(function () {
    const $main = $(this);
    const meta = getDeliveryMeta($main);
    if (!meta) return;

    const products = [];
    $main.find('.product-card.active').each(function () {
      const $card = $(this);
      const pn  = String($card.find('.short-title').text().trim());
      const pq  = Number($card.data('productQuantity') ?? 0); // força número
      const spi = String($card.data('productId'));
      const svi = String($card.data('variantId'));
      if (pq > 0) products.push({ pn, pq, spi, svi });
    });

    if (products.length) deliveries.push({ delivery: Number(meta.number), products });
  });

  return { _delivery_compositions: JSON.stringify(deliveries) };
}

/* ===============================
 * Filter composition (attributes)
 * =============================== */
function buildFilterComposition() {
  const filters = { proteins: {}, restrictions: {} };
  const noneActive = $(SEL.proteinFilterBtns).filter('.active').length === 0;

  $(SEL.proteinFilterBtns).each(function () {
    const val = $(this).data('value');
    const key = `_no_${String(val).split(':')[1].replaceAll('-', '_')}`;
    const isActive = $(this).hasClass('active');
    filters.proteins[key] = noneActive ? 'false' : (isActive ? 'false' : 'true');
  });

  $(SEL.restrictionFilterBtns).each(function () {
    const val = $(this).data('value');
    const key = `_restriction_${String(val).replaceAll('-', '_')}`;
    filters.restrictions[key] = $(this).hasClass('active') ? 'true' : 'false';
  });

  return JSON.stringify(filters);
}

/* ===============================
 * Discount form
 * =============================== */
$(document).on('submit', SEL.discountForm, async function onSubmitDiscount(e) {
  e.preventDefault();

  const $form = $(this);
  const code = $form.find('input[name="discount"]').val().trim();

  try {
    await fetch(`/discount/${code}`, { method: 'GET' });
    const res = await fetch('/cart?view=discount');
    const text = await res.text();
    const data = parseMaybeJsonTwice(text);

    const appliedCodes = Array.isArray(data?.discounts)
      ? data.discounts.map(i => String(i.title).trim().toLowerCase())
      : [];

    const $info = $('.discount-info').removeClass('hidden');
    if (appliedCodes.includes(code.toLowerCase())) {
      $info.text(`Discount code applied: ${code}`);
      await window.CartDrawerAPI.buildCart();
    } else {
      $info.text(`${code} is not a valid discount code.`);
    }
  } catch (err) {
    console.error('Erro ao aplicar desconto:', err);
    $('.discount-info').text('Não foi possível validar o código agora.').removeClass('hidden');
  }
});

/* ===============================
 * Cart total
 * =============================== */
function calculateCartTotal() {
  const pageHandle = sessionStorage.getItem('page_handle') ?? '';
  const partnerActive = pageHandle.includes('partner-');
  let total = parseFloat($(SEL.container).data('priceBundle')).toFixed(2);
  let comparePrice = parseFloat($(SEL.container).data('comparePriceBundle')).toFixed(2);
  total = parseFloat(total) - (partnerActive ? 25.00 : 0.00);
  total = total.toFixed(2);
  const integerPart = total.split('.')[0];
  const decimalPart = total.split('.')[1] || '00';
  const integerCompare = comparePrice.split('.')[0]; 
  const decimalCompare = comparePrice.split('.')[1] || '00';

  $('.total-price-decimal').addClass('hidden');
  $('.total-price').addClass('hidden');
  $('.total-price-omt').removeClass('hidden');
  $('.total-price-omt-decimal').removeClass('hidden');

  $('.compare-price').text(`$${integerCompare}.`);
  $('.compare-price-decimal').text(decimalCompare);
  
  $('.total-price-omt').text(`$${integerPart}.`);
  $('.total-price-omt-decimal').text(decimalPart);
}

function scrollMobile() {
  if ($(window).width() > 768)return;
    const $section = $("#section-products");
    const $sectionCart = $(".section-products__cart");
    const offset = 300;
    $sectionCart.hide();
    $(window).on("scroll", function () {
        const sectionTop = $section.offset().top; 
        const scrollTop = $(window).scrollTop();

        if (scrollTop >= sectionTop - offset) {
            $sectionCart.fadeIn();
             $('.chat-icon').css('bottom', '19%');
        } else {
            $sectionCart.fadeOut();
             $('.chat-icon').css('bottom', '5%');
        }
    });
}

/* ===============================
 * Load meals (one-month)
 * =============================== */
async function loadMeals(week) {
  const plan = getPlanFromPath();
  const url = `${window.Shopify?.routes?.root || '/'}products/${plan}-one-month-trial?view=one-month&week=${week}`;
  const html = await $.get(url);
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const $list = $(doc.querySelector('#product-list-container'));
  console.log('Loaded meals for week:', week);
  console.log('Loaded meals for week:', $list);
  $(SEL.sectionProductsPlan).empty().append($list);
  $('.button-plan').attr('href', `/pages/${plan}-custom-meals`);
}

/* ===============================
 * Filters UI (proteins & restrictions)
 * =============================== */
$(document).on('click', `${SEL.proteinFilterBtns}, ${SEL.restrictionFilterBtns}`, async function (e) {
  e.preventDefault();
  $(".go-to-checkout").prop("disabled", false);
  $(this).toggleClass('active selected');

  const $cards = $(SEL.allCards);
  const $activeProteins = $(SEL.proteinFilterBtns).filter('.active');
  const $activeRestrictions = $(SEL.restrictionFilterBtns).filter('.active');

  // Reset: tudo inativo e qty = 0
  $cards
    .addClass('inactive')
    .removeClass('active')
    .each((_, el) => setQty($(el), 0));
  $(SEL.altCards).removeClass('active').addClass('inactive');

  // Sem filtros → todos ativos com qty 1
  if (!$activeProteins.length && !$activeRestrictions.length) {
    $cards.removeClass('inactive').addClass('active').each((_, el) => setQty($(el), 1));
    $('.product-card.alternative').removeClass('active').addClass('inactive');
    await constructionFromActiveCards(); // <-- atualiza o acordeão
    return;
  }

  // Filtra produtos (proteína = OU) e (restrições = E)
  const matches = $cards.filter(function () {
    const $card = $(this);

    const proteinOk =
      !$activeProteins.length ||
      $activeProteins.toArray().some(btn => {
        const [key, value] = String($(btn).data('value')).split(':');
        return String($card.data(`product-${key}`)) === value;
      });

    const restrictionOk =
      !$activeRestrictions.length ||
      $activeRestrictions.toArray().every(btn => {
        const key = String($(btn).data('value')).replaceAll('_', '-');
        return String($card.data(`product-${key}`)) === 'true';
      });

    return proteinOk && restrictionOk;
  });

  // Agrupa por semana
  const groups = {};
  matches.each(function () {
    const week = $(this).closest('.product-main').data('week');
    (groups[week] ||= []).push(this);
  });

  // Ativa e balanceia (máx 5 por semana, prioridade sem .alternative)
  Object.values(groups).forEach(group => {
    const $primary = $(group).filter(':not(.alternative)');
    const $alts = $(group).filter('.alternative');

    const selected = $primary.toArray().slice(0, 5);
    if (selected.length < 5) selected.push(...$alts.toArray().slice(0, 5 - selected.length));

    const $selected = $(selected).removeClass('inactive').addClass('active');

    if ($selected.length >= 5) {
      $selected.each((_, el) => setQty($(el), 1));
    } else {
      const base = Math.floor(5 / $selected.length);
      let extra = 5 % $selected.length;
      $selected.each((_, el) => setQty($(el), base + (extra-- > 0 ? 1 : 0)));
    }
  });

  // <-- atualiza o acordeão após aplicar filtros/balancear
  await constructionFromActiveCards();
  await noMealsResult();
});

/* ===============================
 * Render selected meals by delivery (accordion)
 * =============================== */
async function constructionFromActiveCards() {
  const compositions = Object.fromEntries(DELIVERY_CLASSES.map(d => [d.label, []]));
  const $container = $(SEL.renderCartItems).empty();

  $('.product-main').each(function () {
    const $main = $(this);
    const meta = getDeliveryMeta($main);
    if (!meta) return;

    $main.find('.product-card.active').each(function () {
      const $card = $(this);
      const qty = $card.data('product-quantity') || 1;
      const title = $card.data('product-short-title') || 'Meal';
      let tagFree = '';

      if ($card.hasClass('breakfast')) {
        tagFree = '<div class="tag-free-container"><span class="tag-free">Free</span></div>';
      };

      compositions[meta.label].push(
        `<div class="acc-line-item">
          <span class="acc-line-item__quantity">${qty}x</span>
          <span class="acc-line-item__title">${title}</span>
          ${tagFree}
         </div>`
      );
    });
  });

  let firstRendered = false;
  Object.entries(compositions).forEach(([label, items]) => {
    if (!items.length) return;
    const openAttr = !firstRendered ? ' open' : '';
    firstRendered = true;

    $container.append(`
      <details class="cart-accordion"${openAttr}>
        <summary class="cart-accordion__summary" data-name="${label}">
          <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0.721893 10.9998C0.721936 11.1975 0.780607 11.3908 0.890491 11.5552C1.00038 11.7197 1.15654 11.8478 1.33924 11.9235C1.52194 11.9991 1.72297 12.0189 1.91692 11.9804C2.11088 11.9418 2.28904 11.8466 2.42889 11.7068L7.42889 6.70679C7.61636 6.51926 7.72168 6.26495 7.72168 5.99979C7.72168 5.73462 7.61636 5.48031 7.42889 5.29279L2.42889 0.292787C2.28904 0.152978 2.11088 0.057771 1.91692 0.0192034C1.72297 -0.0193641 1.52194 0.000439122 1.33924 0.0761092C1.15654 0.151779 1.00038 0.279919 0.890491 0.444329C0.780607 0.608738 0.721936 0.802037 0.721893 0.999787L0.721893 10.9998Z" fill="black"/>
          </svg>
          <span>${label}</span>
        </summary>
        <div class="cart-accordion__body">
          ${items.join('')}


          <div class="cart-noresults__container">
            <div class="cart-noresults__icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2.625C14.5055 2.625 16.8574 3.59958 18.6289 5.37109C20.4004 7.14261 21.375 9.49447 21.375 12C21.375 14.5055 20.4004 16.8574 18.6289 18.6289C16.8574 20.4004 14.5055 21.375 12 21.375C9.49447 21.375 7.14261 20.4004 5.37109 18.6289C3.59958 16.8574 2.625 14.5055 2.625 12C2.625 9.49447 3.59958 7.14261 5.37109 5.37109C7.14261 3.59958 9.49447 2.625 12 2.625ZM5.37988 7.29297C4.39941 8.66648 3.87333 10.3124 3.875 12C3.875 16.4802 7.51982 20.125 12 20.125V20.124C13.6876 20.1257 15.3335 19.6006 16.707 18.6201L17.3076 18.1914L16.7861 17.6689L6.33105 7.21387L5.80859 6.69238L5.37988 7.29297ZM12 3.875C10.3124 3.87333 8.66648 4.39941 7.29297 5.37988L6.69238 5.80859L7.21387 6.33105L17.6689 16.7861L18.1914 17.3076L18.6201 16.707C19.5394 15.4192 20.0592 13.8919 20.1191 12.3154L20.125 11.999C20.1245 7.51929 16.4799 3.875 12 3.875Z" fill="#CC171E" stroke="#CC171E" stroke-width="1.25"/>
              </svg>
            </div>
            <div class="cart-noresults__content">
              <div class="cart-noresults__message">
                <div class="cart-noresults__title">
                  <h3>No meals matched for this week</h3>
                  <p>With your current combination of filters, we’re out of meals to show for this delivery.</p>
                </div>
              </div>
              <div class="cart-noresults__suggestion">
                <div class="cart-noresults__actions">
                  <a class="button-plan" href="${getPlanFromPath()}-custom-meals">Switch to Custom Meal Plan</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </details>
    `);
  });
}

function formatTimestampToDate(timestamp) {
  const date = new Date(Number(timestamp));
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

function verifyDiscount() {
  const storage = localStorage.getItem(key);
  const quizComplete = storage ? JSON.parse(storage).winner : null;
  const discount = quizComplete ? 'INTRO_80' : "null";
  if(discount=="null") return;
  fetch(`/discount/${discount}`).then(()=> {
      fetch('/cart?view=discount', {}).then(function(res){return res.text();})
      .then(async function(data) {
          let dataObject = JSON.parse(JSON.stringify(data));
          dataObject = JSON.parse(dataObject);
          const appliedCodes = dataObject.discounts.map(i => i.title.trim().toLowerCase());
          if (!appliedCodes.includes(discount.trim().toLowerCase())) {
              $('.discount-code-message').text(`Your discount code ${discount} will be applied at checkout.`);
          }
      })
  });
}

function noMealsResult() {
  let allHaveMeals = true;
  $(".product-main").each(function () {
    const $main = $(this);
    const activeCards = $main.find(".product-card:not(.breakfast).active").length;
    if (activeCards == 0) {
      allHaveMeals = false;

      const weekName = $main.find('.product-main__title .week-title').text();
      const $accordion = $(`.cart-accordion__summary[data-name="${weekName}"]`);

      $('.go-to-checkout').prop('disabled', true);

      $accordion.closest('.cart-accordion').attr('open', true);
      $accordion.closest('.cart-accordion')
      .find('.acc-line-item').css("display", "none");

      $accordion.closest('.cart-accordion')
      .find('.cart-noresults__container').css("display", "flex");

      $main.find(".product-card").addClass("inactive");
      $main
        .find(".product-noresults__container")
        .css("display", "flex");
      
    } else {
      $main.find(".product-card.breakfast").removeClass("inactive").addClass("active");
      $main
        .find(".product-noresults__container")
        .css("display", "none");
    }
  });
  $(".go-to-checkout").prop("disabled", !allHaveMeals);
}

$(document).on('click', '.product-noresults__clear-filters', async function (e) {
  e.preventDefault();

  $(SEL.proteinFilterBtns).removeClass('active selected');
  $(SEL.restrictionFilterBtns).removeClass('active selected');

  const $cards = $(SEL.allCards);
  $cards
    .removeClass('inactive')
    .addClass('active')
    .each((_, el) => setQty($(el), 1));

  $(SEL.altCards).removeClass('active').addClass('inactive');
  $(".product-card.breakfast").removeClass("inactive").addClass("active");
  $(".product-noresults__container").css("display", "none");

  await constructionFromActiveCards();
});
$(document).on('click', `${SEL.proteinFilterBtns}`, async function (e) {
  console.log('Protein filter clicked:', this.getAttribute('data-value'));
  let click_type;
  if (this.classList.contains('active')) {
    click_type = 'add';
  } else {
    click_type = 'remove';
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'protein_filter_click',
    properties: {
      protein_selection: this.getAttribute('data-value'),
      click_type: click_type
    }
  });
})
$(document).on('click', `${SEL.restrictionFilterBtns}`, async function (e) {
  console.log('Restriction filter clicked:', this.getAttribute('data-value'));
  let click_type;
  if (this.classList.contains('active')) {
    click_type = 'add';
  } else {
    click_type = 'remove';
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'restriction_filter_click',
    properties: {
      restriction_selection: this.getAttribute('data-value'),
      click_type: click_type
    }
  });
})